export default __webpack_public_path__ + "static/media/papago.f55d8912.png";